export enum SearchTagTypeEnum {
    Tag = "tag",
    Group = "group",
}

export type SearchTagType = SearchTagTypeEnum.Tag | SearchTagTypeEnum.Group;

export type SearchFilterSelectionType = Record<string, string>[];

export interface ISearchTag {
    /** Indicates that the related filter is selected */
    active?: boolean;
    /** Label text of the tag */
    label: string;
    /** Name attribute of the related input element */
    name: string;
    /** Value attribute of the related input element */
    value: string;
}

export interface ISearchFilter {
    /** Label used to display the related tag */
    label: string;
    /** Level of the filter in nested filter data */
    level?: number;
    /** Name attribute of the related input elements */
    name?: string;
    /** Optional child filters */
    tags?: ISearchFilter[];
    /** Value attribute of the related input element */
    value: string;
}
